import {Component, Input, OnInit} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Betriebstaette} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import { ActivatedRoute } from '@angular/router';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'common-ui-betriebstaette-form',
  templateUrl: './betriebstaette-form.component.html'
})
export class BetriebstaetteFormComponent extends FormBaseComponent<Betriebstaette> implements OnInit {

  @Input()
  public stammdaten: Betriebstaette;
  @Input()
  public betriebstaette: Betriebstaette;
  public maxTelefonnummern = 1;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly currentRoute: ActivatedRoute,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  ngOnInit(): void {
    if (this.betriebstaette.stammdatenIndex !== undefined) {
      const stammdatenWithIndex = cloneDeep(
        this.currentRoute.snapshot.data.stammdaten.unternehmen.betriebstaetten[this.betriebstaette.stammdatenIndex]
      );
      this.stammdaten = stammdatenWithIndex.value;
    }
    this.data = this.betriebstaette;
    if (this.data.kommunikationsmittel?.telefonnummern && this.data.kommunikationsmittel.telefonnummern.length > this.maxTelefonnummern) {
      this.data.kommunikationsmittel.telefonnummern = this.data.kommunikationsmittel.telefonnummern.slice(0, this.maxTelefonnummern);
    }
    if (this.data.kommunikationsmittel?.internet && this.data.kommunikationsmittel?.internet instanceof Array) {
      this.data.kommunikationsmittel.internet = this.data.kommunikationsmittel?.internet[0];
    }
    super.ngOnInit();
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      bezeichnung: [this.data.bezeichnung, [
        this.validatorService.required(),
        this.validatorService.maxLength(120)
      ]]
    });
  }
}
